import { z } from 'zod'

const zAccommodationId = z
  .string()
  .regex(/^\d{8}$/)
  .brand('AccommodationId')
export type AccommodationId = z.infer<typeof zAccommodationId>

export const zDateText = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/)
  .brand('DateText')
export type DateText = z.infer<typeof zDateText>
export function validateDateText(input: unknown): DateText | undefined {
  const result = zDateText.safeParse(input)
  return result.success ? result.data : undefined
}

export const zHourMinute = z
  .string()
  .regex(/^\d{2}:\d{2}$/)
  .brand('HourMinute')
export type HourMinute = z.infer<typeof zHourMinute>
export function validateHourMinute(input: unknown): HourMinute | undefined {
  const result = zHourMinute.safeParse(input)
  return result.success ? result.data : undefined
}

const zSpotId = z.string().regex(/^\d+$/).brand('SpotId')
export type SpotId = z.infer<typeof zSpotId>

export const zPlanId = z
  .string()
  .regex(/^\d{8}$/)
  .brand('PlanId')
export type PlanId = z.infer<typeof zPlanId>
export function validatePlanId(input: unknown): PlanId | undefined {
  const result = zPlanId.safeParse(input)
  return result.success ? result.data : undefined
}

export const zRestaurantId = z
  .string()
  .regex(/^\d{6}$/)
  .brand('RestaurantId')
export type RestaurantId = z.infer<typeof zRestaurantId>
export const validateRestaurantId = (restaurantId: unknown): RestaurantId | undefined => {
  const result = zRestaurantId.safeParse(restaurantId)
  return result.success ? result.data : undefined
}

export const zTimesaleId = z.string().regex(/^\d+$/).brand('TimesaleId')
export type TimesaleId = z.infer<typeof zTimesaleId>

export const zSpecialFeatureId = z.string().regex(/^\d+$/).brand('SpecialFeatureId')
export type SpecialFeatureId = z.infer<typeof zSpecialFeatureId>

export type AffiliateSiteId = string & { __affiliateSiteIdBrand: any }
export type CancelPolicyId = string & { __cancelPolicyIdBrand: any }
export type ChildMenuId = string & { __childMenuIdBrand: any }
export type CityId = string & { __cityIdBrand: any }
export type CourseId = string & { __courseIdBrand: any }
export type DateTime = string & { __dateTimeBrand: any }
export type DiscountCouponCode = string & { __discountCouponCodeBrand: any }
export const GenreCode = z.string().regex(/^[0-9]{5}$/).brand('GenreCode')
export type GenreCode = z.infer<typeof GenreCode>
export type HtmlFragment = string & { __htmlFragmentBrand: any }
export type KiwaminoArticleId = string & { __kiwaminoArticleIdBrand: any }
export const LargeAreaCode = z.string().regex(/^[0-9]{2}$/).brand('LargeAreaCode')
export type LargeAreaCode = z.infer<typeof LargeAreaCode>
export const MediumAreaCode = z.string().regex(/^[0-9]{3}$/).brand('MediumAreaCode')
export type MediumAreaCode = z.infer<typeof MediumAreaCode>
export const MinimumAreaCode = z.string().regex(/^[0-9]{4}$/).brand('MinimumAreaCode')
export type MinimumAreaCode = z.infer<typeof MinimumAreaCode>
export type OptionMenuId = string & { __optionMenuIdBrand: any }
export type PaymentCardId = string & { __paymentCardIdBrand: any }
export type ReservationId = string & { __reseervationIdBrand: any }
export type RestaurantTagId = string & { __restaurantTagIdBrand: any }
export type SeatId = string & { __seatIdBrand: any }
export const SmallAreaCode = z.string().regex(/^[0-9]{3}$/).brand('SmallAreaCode')
export type SmallAreaCode = z.infer<typeof SmallAreaCode>
export type SpecialId = string & { __specialIdBrand: any }
export type TownId = string & { __townIdBrand: any }

const courseIdSchema = z.string().regex(new RegExp(/^[0-9]{8}$/))

export const validateCourseId = (courseId: unknown): CourseId | undefined => {
  const validatedCourseId = courseIdSchema.safeParse(courseId)
  return validatedCourseId.success ? (validatedCourseId.data as CourseId) : undefined
}

const zPointRewardProgramId = z.string().regex(/^\d+$/).brand('PointRewardProgramId')
export type PointRewardProgramId = z.infer<typeof zPointRewardProgramId>

const zPointRewardSettingId = z.string().regex(/^\d+$/).brand('PointRewardSettingId')
export type PointRewardSettingId = z.infer<typeof zPointRewardSettingId>
